var _ellipse, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.667,
  cy: 12.167,
  rx: 4.667,
  ry: 2.333,
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6.667,
  cy: 5.167,
  r: 2.667,
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.187 7.07A4.02 4.02 0 0 1 9.02 8.402a2.75 2.75 0 1 0 1.065-5.319c.305.5.503 1.07.564 1.68a1.25 1.25 0 0 1-.46 2.305ZM12.668 12.204c-.007.41-.123.803-.333 1.17a5.78 5.78 0 0 0 .686-.234c.398-.166.753-.376 1.015-.635.265-.26.464-.6.464-1.005 0-.404-.199-.744-.463-1.005-.263-.259-.618-.47-1.016-.635-.682-.284-1.56-.467-2.52-.514.668.34 1.214.766 1.59 1.25.198.056.38.119.545.187.326.136.557.285.699.425.14.137.165.236.165.292 0 .056-.025.155-.165.293-.138.135-.358.279-.667.41Z",
  fill: "currentColor"
})));
export default SvgUsers;